import { EnrichedCartItemType } from "@/models/cart";
import { CreateInsightFormSchemaType } from "@/pages/Store/CreateInsight/utils";

export function resolveTotalsFromCartItem({
  currency_minor_unit,
  totalPrice,
  totalFeesTax,
}) {
  try {
    const minorUnit = Number(currency_minor_unit ?? 2);
    const divisor = Math.pow(10, minorUnit);

    const total =
      currency_minor_unit === 0
        ? Number(totalPrice)
        : Number(totalPrice) / divisor;

    const tax = Number(totalFeesTax) / divisor;
    const subtotal = total - tax;

    const toFixedString = (val: number) => val.toFixed(2);

    return {
      total: `$${toFixedString(total)}`,
      totalFeesTax: `$${toFixedString(tax)}`,
      subtotal: `$${toFixedString(subtotal)}`,
    };
  } catch (error) {
    console.error("Error resolving totals from cart item:", error);
    return { total: 0, totalFeesTax: 0, subtotal: 0 };
  }
}

export function resolveInsightDetails(
  item: EnrichedCartItemType
): CreateInsightFormSchemaType | null {
  try {
    // The item should have a category slug of "insights"
    if (
      !item.categories ||
      item.categories.length === 0 ||
      item.categories.some((category) => category.slug !== "insights")
    )
      throw new Error("Item is not an Insight");
    const configData = item.item_data.find(
      (data: any) => data.name === "JSON Config"
    );

    if (!configData) {
      throw new Error('No "JSON Config" found in item_data');
    }

    const raw_item_value = configData.value;
    const parsed_item_value = JSON.parse(raw_item_value);

    return parsed_item_value as CreateInsightFormSchemaType;
  } catch (error) {
    console.error("Error resolving insight details:", error);
    return null;
  }
}
